<h1>{{ title }}</h1>
{{ active }}
<ng-content></ng-content>
